define(['jquery', 'c21/charts/VerticalChart', 'c21/internationalization'], function ($, VerticalChart, internationalization) {
   "use strict";

   return function($chartUnorderedList, $chartSelect, $legendLineSpan, $dataSourceNameLineSpan) {
      // !@#($j
      //if ($chartUnorderedList === undefined) {
      //   var weatherChart = new WeatherChart();
      //   return;
      //}
      
      var m_chart = new VerticalChart($chartUnorderedList);
      var m_oData = null; // {high: {jan: 20, feb: 30 ..}, low: {...},
                           // precipitation: {...}, source_name: "My Weather
                           // Station"}
      
      var setChartValues = function(o, p) {
         m_chart.resetData();      
         m_chart.addBar("Jan", p(o.jan));
         m_chart.addBar("Feb", p(o.feb));
         m_chart.addBar("Mar", p(o.mar));
         m_chart.addBar("Apr", p(o.apr));
         m_chart.addBar("May", p(o.may));
         m_chart.addBar("Jun", p(o.jun));
         m_chart.addBar("Jul", p(o.jul));
         m_chart.addBar("Aug", p(o.aug));
         m_chart.addBar("Sep", p(o.sep));
         m_chart.addBar("Oct", p(o.oct));
         m_chart.addBar("Nov", p(o.nov));
         m_chart.addBar("Dec", p(o.dec));
         
         var bValuesDiffer = false;
         var last = null;
         for (var val in o) {
            if (last === null) { last = o[val]; }
            if (last !== o[val]) {
               bValuesDiffer = true;
            } 
         }
         if (bValuesDiffer === false) {
            m_chart.setNoDataText("No Data Available");
         } else {
            m_chart.setNoDataText(null);
         }
            
         m_chart.autoAdjustViewport();
         m_chart.renderBars();
      };
      
      var showChartTemperatureHigh = function() {
         m_chart.setBarLabelPostFix("&deg;");
         setChartValues(m_oData.high, Math.round);
         $legendLineSpan.html("(" + internationalization.getString('in Degrees Fahrenheit') + ")");
      };
      var showChartTemperatureLow = function() {
         m_chart.setBarLabelPostFix("&deg;");
         setChartValues(m_oData.low, Math.round);
         $legendLineSpan.html("(" + internationalization.getString('in Degrees Fahrenheit') + ")");
      };
      var showChartPrecipitation = function() {
         m_chart.setBarLabelPostFix('"');
         setChartValues(m_oData.precipitation, function(f) {
            return parseFloat(parseFloat(f).toFixed(2));
         });
         $legendLineSpan.html("(in Inches)");
      };
      var showChartRelativeHumidity = function() {
         m_chart.setBarLabelPostFix("%");
         setChartValues(m_oData.relative_humidity, Math.round);
         $legendLineSpan.html("(in Saturation Percentage)");
      };
      
      $chartSelect.change(function() {
         switch ($(this).val()) {
            case 'high':
               showChartTemperatureHigh();
               break;
            case 'low':
               showChartTemperatureLow();
               break;
            case 'precipitation':
               showChartPrecipitation();
               break;

            default:
               //alert($(this).val() + " is not a valid chart type.");
         }
      });
      
      // Public
      this.setData = function(oData) {
         m_oData = oData;
         $dataSourceNameLineSpan.html(internationalization.getString("Weather Data Source") + ": " + m_oData.source_name);
      };
      this.showChartTemperatureHigh = showChartTemperatureHigh;
      this.showChartTemperatureLow = showChartTemperatureLow;
      this.showChartPrecipitation = showChartPrecipitation;
      this.showChartRelativeHumidity = showChartRelativeHumidity;
      
      m_chart.setMinMaxHeight(5, 120);
   };
});
